import { ESeoUrlActionType } from 'shared/map-search/actions/seoUrl';

import { TReduxActions } from '../../actions';

/**
 * @todo будет удалено в рамках CD-169251
 */
export function seoUrlReducer(state: string | null = null, action: TReduxActions): string | null {
  switch (action.type) {
    case ESeoUrlActionType.ClearSeoUrl:
      return null;
    default:
      return state;
  }
}
